import React from 'react';

export default function Menu(props){
    return (
        <div className="menuList">
               <span>{props.value}</span>
               <div className="line"></div>
        </div>
    )
}